import React, {Component} from 'react';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Table
} from 'reactstrap'

const sprintf = require('sprintf-js').sprintf;
const fixGPAFloat = require('../utilities/fixGPAFloat');
const isOnLOP = require('../utilities/isOnLOP');
const R = require('ramda')

class Reports extends Component {

  constructor(props) {
    super(props);
    this.classOfList = R.uniq(R.map(s => s.classOf, R.values(props.studentObjs)));
    this.classOfList = R.sort((a,b) => a < b ? -1 : 1, this.classOfList);
    this.state = {
      classOf: 'disabled',
      grade: 'disabled',
      lopStatus: 'disabled',
      counselor: 'disabled',
      finance: 'disabled',
      library: 'disabled',
      minLopCount: 'disabled',
      maxLopCount: 'disabled',
      acGPAGreaterThan: 'disabled',
      acGPALessThan: 'disabled',
      citGPAGreaterThan: 'disabled',
      citGPALessThan: 'disabled'
    }
    this.onChange = this.onChange.bind(this);
    this.filterStudentList = this.filterStudentList.bind(this);
    this.goToStudent = this.goToStudent.bind(this);
  }

  goToStudent(evt) {
    let stuID = evt.currentTarget.getAttribute('data-key');
    this.props.dispatch('DATA:SELECT_STUDENT', stuID);
  }

  onChange(evt) {
    let field = evt.currentTarget.getAttribute('name');
    this.setState({[field]: evt.currentTarget.value});
  }

  filterStudentList(list) {
    console.log(list);
    let _this = this;
    if (this.state.classOf !== 'disabled') {
      list = R.filter(s => s.classOf+'' === _this.state.classOf+'', list);
    }
    if (this.state.grade !== 'disabled') {
      list = R.filter(s => s.grade+'' === _this.state.grade+'', list);
    }
    if (this.state.lopStatus !== 'disabled') {
      list = R.filter(s => {
        let onLOP = isOnLOP(s);
        return (_this.state.lopStatus === 'on') ? onLOP : !onLOP
      }, list);
    }
    if (this.state.finance !== 'disabled') {
      list = R.filter(s => {
        return (s.finance && _this.state.finance === 'on');
      }, list)
    }
    if (this.state.library !== 'disabled') {
      list = R.filter(s => {
        return (s.library && _this.state.library === 'on');
      }, list)
    }
    if (this.state.minLopCount !== 'disabled') {
      list = R.filter (s => _this.state.minLopCount <= s.lopCount, list);
    }
    if (this.state.maxLopCount !== 'disabled') {
      list = R.filter (s => s.lopCount <= _this.state.maxLopCount, list);
    }
    // If acGPA less than is a number then check GPA range
    if (!isNaN(this.state.acGPALessThan)) {
      list = R.filter (s => _this.state.acGPALessThan <= s.acGPA, list);
    }
    // If acGPA is disabled, then filter out acGPAs that are blank
    if (this.state.acGPAGreaterThan === 'nogpa') {
      list = R.filter (s => s.acGPA === '', list);
    }
    if (!isNaN(this.state.acGPAGreaterThan)) {
      list = R.filter (s => s.acGPA <= _this.state.acGPAGreaterThan, list);
    }
    if (!isNaN(this.state.citGPALessThan)) {
      list = R.filter (s => _this.state.citGPALessThan <= s.citGPA, list);
    }
    if (this.state.citGPAGreaterThan === 'nogpa') {
      list = R.filter (s => s.citGPA === '', list);
    }
    if (!isNaN(this.state.citGPAGreaterThan)) {
      list = R.filter (s => s.citGPA <= _this.state.citGPAGreaterThan, list);
    }
    console.log(list);
    return list
  }

  render() {
    let _this = this;
    let lopCount = R.range(0, 51);
    let gpaOptions = R.reverse(R.range(0, 51));
    let studentList = this.filterStudentList(R.values(this.props.studentObjs));
    studentList = R.sort((a,b) => (a.lastName+','+a.firstName < b.lastName+','+b.firstName) ? -1 : 1, studentList);
    return (
      <div>
        <Row className="master-detail-top-separator">
          <Col md={4} className="border-right">
            <Form onSubmit={this.onSubmit}>
              <FormGroup row>
                <Label for="classOf" md={7}>Class of</Label>
                <Col md={5}>
                  <Input type="select"
                         name="classOf"
                         id="classOf"
                         value={this.state.classOf}
                         onChange={this.onChange}>
                    <option value="disabled">Disabled</option>
                    {
                      // this.classOfList.map(yr => <option key={'yr'+yr} value={yr}>C/O {yr === '' ? 'None' : yr}</option>)
                      this.classOfList.map(yr => <option key={'yr'+yr} value={yr}>{yr === '' ? 'No C/O listed' : 'C/O '+yr}</option>)
                    }
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="classOf" md={7}>Grade</Label>
                <Col md={5}>
                  <Input type="select"
                         name="grade"
                         id="grade"
                         value={this.state.grade}
                         onChange={this.onChange}>
                    <option value="disabled">Disabled</option>
                    <option value="12">12</option>
                    <option value="11">11</option>
                    <option value="10">10</option>
                    <option value="9">9</option>
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="finance" md={7}>LOP status</Label>
                <Col md={5}>
                  <Input type="select"
                         name="lopStatus"
                         id="lopStatus"
                         value={this.state.lopStatus}
                         onChange={this.onChange}>
                    <option value="disabled">Disabled</option>
                    <option value="on">On</option>
                    <option value="off">Not on</option>
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="finance" md={7}>Finance</Label>
                <Col md={5}>
                  <Input type="select"
                         name="finance"
                         id="finance"
                         value={this.state.finance}
                         onChange={this.onChange}>
                    <option value="disabled">Disabled</option>
                    <option value="on">On</option>
                    <option value="off">Clear</option>
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="library" md={7}>Library</Label>
                <Col md={5}>
                  <Input type="select"
                         name="library"
                         id="library"
                         value={this.state.library}
                         onChange={this.onChange}>
                    <option value="disabled">Disabled</option>
                    <option value="on">On</option>
                    <option value="off">Clear</option>
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="minLopCount" md={7}>Min LOP count</Label>
                <Col md={5}>
                  <Input type="select"
                         name="minLopCount"
                         id="minLopCount"
                         value={this.state.minLopCount}
                         onChange={this.onChange}>
                    <option key={'minnone'} value="disabled">Disabled</option>
                    {
                      lopCount.map(i => <option key={'min'+i} value={i}>{i}</option>)
                    }
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="maxLopCount" md={7}>Max LOP count</Label>
                <Col md={5}>
                  <Input type="select"
                         name="maxLopCount"
                         id="maxLopCount"
                         value={this.state.maxLopCount}
                         onChange={this.onChange}>
                    <option key={'maxnone'} value="disabled">Disabled</option>
                    {
                      lopCount.map(i => <option key={'max'+i} value={i}>{i}</option>)
                    }
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="acGPAGreaterThan" md={7}>Ac GPA greater than:</Label>
                <Col md={5}>
                  <Input type="select"
                         name="acGPAGreaterThan"
                         id="acGPAGreaterThan"
                         value={this.state.acGPAGreaterThan}
                         onChange={this.onChange}>
                    <option key={'aggtnone'} value="disabled">Disabled</option>
                    <option key={'aggtnogpa'} value="nogpa">No GPA</option>
                    {
                      gpaOptions.map(i => <option key={'aggt'+i} value={(i/10)+''}>{sprintf('%3.1f', i/10)}</option>)
                    }
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="acGPALessThan" md={7}>Ac GPA less than:</Label>
                <Col md={5}>
                  <Input type="select"
                         name="acGPALessThan"
                         id="acGPALessThan"
                         disabled={this.state.acGPAGreaterThan === 'nogpa'}
                         value={this.state.acGPALessThan}
                         onChange={this.onChange}>
                    <option key={'agltnone'} value="disabled">Disabled</option>
                    {
                      gpaOptions.map(i => <option key={'aglt'+i} value={(i/10)+''}>{sprintf('%3.1f', i/10)}</option>)
                    }
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="citGPAGreaterThan" md={7}>Cit GPA greater than:</Label>
                <Col md={5}>
                  <Input type="select"
                         name="citGPAGreaterThan"
                         id="citGPAGreaterThan"
                         value={this.state.citGPAGreaterThan}
                         onChange={this.onChange}>
                    <option key={'cggtnone'} value="disabled">Disabled</option>
                    <option key={'cggtnogpa'} value="nogpa">No GPA</option>
                    {
                      gpaOptions.map(i => <option key={'cggt'+i} value={(i/10)+''}>{sprintf('%3.1f', i/10)}</option>)
                    }
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="citGPALessThan" md={7}>Cit GPA less than:</Label>
                <Col md={5}>
                  <Input type="select"
                         name="citGPALessThan"
                         id="citGPALessThan"
                         disabled={this.state.citGPAGreaterThan === 'nogpa'}
                         value={this.state.citGPALessThan}
                         onChange={this.onChange}>
                    <option key={'cgltnone'} value="disabled">Disabled</option>
                    {
                      gpaOptions.map(i => <option key={'cglt'+i} value={(i/10)+''}>{sprintf('%3.1f', i/10)}</option>)
                    }
                  </Input>
                </Col>
              </FormGroup>
            </Form>
          </Col>
          <Col md={8}>
            <h5>{studentList.length} students displayed</h5>
            <Table size="sm" className="top-spacer list-scroll roster-details">
              <thead>
              <tr>
                <th className="text-center">On LOP</th>
                <th className="text-center">Stu ID</th>
                <th>Name</th>
                <th className="text-center">C/O | Gr</th>
                <th className="text-center">Ac GPA</th>
                <th className="text-center">Cit GPA</th>
                <th className="text-center">Fin</th>
                <th className="text-center">Lib</th>
                <th className="text-center">LOP records</th>
              </tr>
              </thead>
              <tbody>
                {
                  studentList.map(stu => {
                    let onLOP = isOnLOP(stu);
                    return (
                      <tr key={stu.stuID}>
                        <td className={(onLOP) ? "on-lop text-center" : "text-center"}>{(onLOP) ? 'ON' : ''}</td>
                        <td className={(onLOP) ? "on-lop text-center" : "text-center"}>{stu.stuID}</td>
                        <td onClick={_this.goToStudent} data-key={stu.stuID}
                            className={(onLOP) ? "on-lop cursor-pointer" : "cursor-pointer"}>{stu.lastName + ', ' + stu.firstName}</td>
                        <td className="text-center">{stu.classOf + ' | ' + sprintf('%02d', stu.grade)}</td>
                        <td
                          className={(!isNaN(stu.acGPA) && stu.acGPA < 2.0) ? "text-center on-lop" : "text-center"}>{fixGPAFloat(stu.acGPA)}</td>
                        <td
                          className={(!isNaN(stu.citGPA) && stu.citGPA < 2.0) ? "text-center on-lop" : "text-center"}>{fixGPAFloat(stu.citGPA)}</td>
                        <td className={(stu.finance) ? "text-center on-lop" : "text-center"}>{(stu.finance) ?
                          <span className="on-lop">{`\u2588`}</span> : <span className="off-lop-green">{`\u2588`}</span>}</td>
                        <td className={(stu.library) ? "text-center on-lop" : "text-center"}>{(stu.library) ?
                          <span className="on-lop">{`\u2588`}</span> : <span className="off-lop-green">{`\u2588`}</span>}</td>
                        <td
                          className={(stu.lopCount > 0) ? "text-center on-lop" : "text-center"}>{stu.lopCount}</td>
                      </tr>

                    )
                  })
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Reports



// WEBPACK FOOTER //
// ./src/views/Reports.js